<template>
  <div class="c-discounts">
    <template v-if="!isReady">
      <slot name="stub"></slot>
    </template>
    <div v-else
         class="c-discount c-discount--campaign"
         v-for="discount in filteredDiscounts"
         :key="discount.id"
         :class="{'is-expanded': isToggledPane(discount.id)}"
         :style="getStyles(discount.bannerSettings)"
         @click="togglePane(discount.id)">
      <div class="c-discount__title">
        <span v-show="discount.bannerSettings.icon" :class="`u-mr-1 u-fa u-${discount.bannerSettings.icon}`"></span>
        <span v-text="discount.name"></span>
      </div>
      <transition name="fade">
        <div class="c-discount__text" v-show="isToggledPane(discount.id)" v-html="discount.comment"></div>
      </transition>
    </div>
  </div>
</template>
<script lang="ts">
import { Component } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { Discount, DiscountBannerSetting } from '../store/modules/discounts';
import BaseComponent from './Base';

const DiscountsStore = namespace('discounts');

    @Component
    export default class DiscountBanners extends BaseComponent {
        @DiscountsStore.State('discounts') protected readonly discounts: Discount[];

        protected panesState: Array<{ id: number, state: boolean }> = [];

        protected get filteredDiscounts(): Discount[] {
            const discounts: Discount[] = [];
            const discount = this.discounts.find((d) => {
                return d.bannerSettings.enabled && d.name !== null && d.name.length > 0 && d.comment !== null && d.comment.length > 0;
            });
            if (discount) {
                discounts.push(discount);
            }
            this.panesState.splice(0, this.panesState.length);
            discounts.forEach((d) => this.panesState.push({ id: d.id, state: false }));
            return discounts;
        }

        protected get isReady(): boolean {
            return this.filteredDiscounts.length > 0;
        }

        protected togglePane(id: number): void {
            this.panesState.forEach((pane) => pane.state = pane.id === id ? !pane.state : false);
        }

        protected isToggledPane(id: number): boolean {
            return !!this.panesState.find((pane) => pane.id === id && pane.state);
        }

        protected getStyles(setting: DiscountBannerSetting): { [p: string]: any } {
            return {
                color: setting.fontColor,
                backgroundColor: setting.bgColor,
            };
        }
    }
</script>
